import { IEvBreadcrumb } from 'src/common/components/ev-breadcrumbs/EvBreadcrumbs';
import { RoutesHelper } from 'src/common/helpers/RoutesHelper';
import { getBaseURL } from 'src/common/helpers/UrlNormalizingHelper';
import { SessionViews } from 'src/common/types/WfaSessionViews';

import { MAIN_PAGE_NAV_LABEL } from './MfaDashboardConsts';

export const getMfaBreadcrumbRoutes = (sessionId: string, sessionName: string): IEvBreadcrumb[] => [
	{
		id: MAIN_PAGE_NAV_LABEL,
		url: RoutesHelper.getMfaDashboardPath(),
		title: MAIN_PAGE_NAV_LABEL
	},
	{
		id: sessionId,
		url: '',
		title: sessionName
	}
];

export const getCurrentMfaFullUrl = (sessionId: string): string =>
	`${getBaseURL()}${RoutesHelper.getMfaSessionPath(sessionId, SessionViews.OVERVIEW)}`;
